<template>
  <div style="margin-right: 4px; display: inline-flex; flex-wrap: wrap">
    <img class="d-image" @click="handleClick" :src="mainUrl" alt=""/>
    <light-box v-if="showLightBox" @onClosed="onClosed" :media="media"/>
  </div>
</template>

<script>
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
import LightBox from 'vue-image-lightbox'
import {get} from 'lodash'


export default {
  name: 'DImgLightBox',
  components: {
    LightBox,
  },
  props: {
    url: {
      type: [Array, String],
      default: '',
    },
    list: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      showLightBox: false,
    }
  },
  computed: {
    mainUrl() {
      if (typeof this.url === 'string') {
        return this.getImage(this.url, 64, 'auto')
      }
      return this.getImage(get(this.url, '[0]', ''), 64, 'auto')
    },
    media() {
      const items =
          this.list && this.list.length > 0
              ? this.list
              : typeof this.url === 'string'
                  ? [this.url]
                  : this.url

      return items.map((item) => ({
        thumb: this.getImage(item, 64, 'auto'),
        src: item,
      }))
    },
  },
  methods: {
    getImage() {
      return this.url
    },
    handleClick() {
      this.showLightBox = true
    },
    onClosed() {
      this.showLightBox = false
    },
  },
}
</script>

<style scoped>
.d-image {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  object-fit: contain;
  cursor: zoom-in;
  border: solid 1px #17494e1f;
}
</style>
